import { ChartProcessorContext, isVegaLiteSpec } from './index';

function applyFormattingToEncoding(encoding: any, fieldName: string, fieldTitle: string) {
    const tooltip: any[] = [];

    if (encoding.color?.field && encoding.color.field !== '__color_patch__') {
        tooltip.push({
            field: encoding.color.field,
            type: encoding.color.type || 'nominal',
            title: encoding.color.legend?.title || encoding.color.field,
        });

        encoding.color.legend = null;
    }

    if (encoding.x?.field) {
        tooltip.push({
            field: encoding.x.field,
            type: encoding.x.type || 'temporal',
            title: encoding.x.axis?.title || encoding.x.title || encoding.x.field,
        });
    }

    if (encoding?.color) {
        delete encoding.color;
    }

    tooltip.push({
        field: 'label',
        type: 'nominal',
        title: fieldTitle || fieldName,
    });

    encoding.tooltip = tooltip;

    return encoding;
}

export function processMultiChart({ spec, isBig, colors }: ChartProcessorContext) {
    const newSpec = { ...spec };

    if (!isVegaLiteSpec(newSpec)) return newSpec;

    const layers = (newSpec as any).layer;

    if (Array.isArray(layers)) {
        for (let i = 0; i < layers.length; i++) {
            const layer = layers[i];
            const encoding = layer.encoding;
            const yField = encoding?.y?.field;
            const yTitle = encoding?.y?.axis?.title || encoding?.y?.title || yField;

            const color = colors[i % colors.length];

            if (yField) {
                layer.encoding = applyFormattingToEncoding(encoding, yField, yTitle);

                layer.mark = {
                    ...layer.mark,
                    point: true,
                    color,
                };
            }
        }
    }

    if (isBig) {
        (newSpec as any).height = 500;
        (newSpec as any).width = 600;
    }

    return newSpec;
}
